<template>
    <section>
        <TopBackgroundComponent/>
        <EventComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import EventComponent from '../components/events/HospitalEventComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
  /*  */
</style>